import { render, staticRenderFns } from "./WorkoutList.vue?vue&type=template&id=143ea3c8&scoped=true&"
import script from "./WorkoutList.vue?vue&type=script&lang=js&"
export * from "./WorkoutList.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutList.vue?vue&type=style&index=0&id=143ea3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ea3c8",
  null
  
)

export default component.exports